






















































import Vue, { PropType } from "vue";
import { center, zoom } from "./Map Files/mapInfo";
interface ViewBtns {
  viewAlt3ABtn: boolean;
  viewProjLimBtn: boolean;
  viewAlt3EBtn: boolean;
  viewAlt5GBtn: boolean;
}
interface MapLayers {
  projectLimits: boolean;
  alt5GLayer: boolean;
  alt3ELayer: boolean;
  alt3ALayer: boolean;
}
interface Details {
  text: string;
  altText: string;
  desc: string;
  overlay: boolean;
  image: string;
  viewBtns: object;
  mapLayers: object;
}
export default Vue.extend({
  name: "GoogleMap",
  created() {
    this.isHomePage = this.homePage;
    if (this.isHomePage) {
      this.updatedLayers = this.layers[3];
      this.details.viewBtns = this.viewBtns[3];
    } else {
      this.updatedLayers = this.details.mapLayers
        ? this.details.mapLayers
        : this.MapLayers;
    }
  },
  props: {
    ViewBtns: { type: Object as PropType<ViewBtns> },
    MapLayers: { type: Object as PropType<MapLayers> },
    details: { type: Object as PropType<Details> },
    homePage: { type: Boolean }
  },
  data: () => ({
    center: center as Record<string, number>,
    zoom: zoom as number,
    descList: [
      "This alternative consists of a long-span bridge for the I-10 mainline over the Calcasieu River that touches down west of Sampson Street. The westbound off-ramp to Sampson would curve under the new bridge and touch down on Isle of Capri Boulevard near Mike Hooks Road. The other three ramps would be improved in the same locations and the at-grade railroad crossings at Sampson Street would remain. An extension of Sulphur Avenue crossing the river to the north of the mainline with a moveable bridge would be provided as an alternate route to avoid the railroad crossings. This extension would connect with the I-10 mainline east of the river, but only westbound exit and eastbound entrance ramps would be provided.",
      "This alternative consists of a long-span bridge for the I-10 mainline over the Calcasieu River that touches down west of Sampson Street. The westbound off-ramp to Sampson would curve under the new bridge and touch down on Isle of Capri Boulevard near Mike Hooks Road. The other three ramps would be improved in the same locations and the at-grade railroad crossings at Sampson Street would remain. An extension of Sulphur Avenue crossing the river to the north of the mainline with a moveable bridge would be provided as an alternate route to avoid the railroad crossings.  This extension would connect with the I-10 mainline east of the river. Four ramps, eastbound entrance and exit and westbound entrance and exit, would be provided.",
      "This alternative consists of a bridge with the westbound approach built on a retaining wall for the I-10 mainline over the Calcasieu River.  This would allow a fully directional interchange to be elevated over the I-10 mainline. At-grade Sampson Street would also be elevated, connecting four ramps to the interstate and providing a grade separation for the railroad crossings. Tracks on the southside of the bridge would have to be relocated.",
      ""
    ],
    layers: [
      {
        projectLimits: false,
        alt3ALayer: true,
        alt3ELayer: false,
        alt5GLayer: false,
        updated: true
      },
      {
        projectLimits: false,
        alt3ALayer: false,
        alt3ELayer: true,
        alt5GLayer: false,
        updated: true
      },
      {
        projectLimits: false,
        alt3ALayer: false,
        alt3ELayer: false,
        alt5GLayer: true,
        updated: true
      },
      {
        projectLimits: true,
        alt3ALayer: false,
        alt3ELayer: false,
        alt5GLayer: false,
        updated: true
      }
    ],
    viewBtns: [
      {
        viewAlt5GBtn: false,
        viewAlt3EBtn: false,
        viewAlt3ABtn: true,
        viewProjLimBtn: false
      },
      {
        viewAlt5GBtn: false,
        viewAlt3EBtn: true,
        viewAlt3ABtn: false,
        viewProjLimBtn: false
      },
      {
        viewAlt5GBtn: true,
        viewAlt3EBtn: false,
        viewAlt3ABtn: false,
        viewProjLimBtn: false
      },
      {
        viewAlt5GBtn: false,
        viewAlt3EBtn: false,
        viewAlt3ABtn: false,
        viewProjLimBtn: true
      }
    ],
    updated: false,
    updatedLayers: {},
    updatedViewButtons: {},
    isHomePage: false
  }),
  methods: {
    buttonClass(active: boolean) {
      return active ? "google-map-button-2" : "google-map-button";
    },
    handleClick: function(title: string, index: number) {
      this.updated = true;
      this.isHomePage = false;
      this.$emit("update-title", title);
      this.$emit("update-desc", this.descList[index]);
      this.updatedLayers = this.layers[index];
      this.updatedViewButtons = this.viewBtns[index];
      this.clearLayers();
    },
    clearLayers() {
      this.$props.MapLayers.projectLimits = false;
      this.$props.MapLayers.alt5GLayer = false;
      this.$props.MapLayers.alt3ELayer = false;
      this.$props.MapLayers.alt3ALayer = false;
    }
  }
});
